import React from 'react'
import styled from 'styled-components'
import { SeedPedigree } from 'modules/domain/seedTracker/types'

const PedigreeLabelRoot = styled.div<{ $backgroundColor: string }>`
  display: flex;
  height: 22px;
  padding: 0 12px;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  background: ${(props) => props.$backgroundColor};
  color: white;
  font-size: 12px;
  width: fit-content;
`

export function getPedigreeBackgroundColor(pedigree: SeedPedigree): string {
  switch (pedigree) {
    case SeedPedigree.Certified:
      return '#20B02E'
    case SeedPedigree.Registered:
      return '#5C3700'
    case SeedPedigree.Foundation:
      return '#FFAB2E'
    case SeedPedigree.Select:
      return '#037BFF'
    case SeedPedigree.Breeder:
      return '#776D6D'
    default:
      return '#776D6D'
  }
}

export const PedigreeTag: React.FC<{ pedigree: SeedPedigree }> = ({ pedigree }) => (
  <PedigreeLabelRoot $backgroundColor={getPedigreeBackgroundColor(pedigree)}>{pedigree}</PedigreeLabelRoot>
)
